import { MultiCheckboxField, PortalInputField } from 'components/FormControls';
import { InjectedFormProps, ITranslateProps } from 'models/common';
import { Field } from 'redux-form';
import { IProductForm } from 'models/product/product';
import * as React from 'react';
import { connect } from 'react-redux';
import { IStore } from 'redux/IStore';
import { PortalPageSection } from 'components/PortalStructure';
import * as c from 'models/constants';
import { createDomainValueOptions } from 'helpers/common';
import { attributesDefinitions, attributesToShow } from 'helpers/products';
import { Expandable } from 'components/Common/Expandable';

interface IProps extends InjectedFormProps<IProductForm>, ReturnType<typeof mapStateToProps>, ITranslateProps {
	currentFormValues: IProductForm;
}

class EditProductAttributesForm extends React.Component<IProps> {
	constructor(params) {
		super(params);
	}
	private get attibutesToShow(): c.AttributeName[] {
		return attributesToShow(this.props.currentFormValues, 'main');
	}

	public render() {
		const { t } = this.props;
		const inputs = this.attibutesToShow
			.map((attr) => {
				const definition = attributesDefinitions[attr];
				if (!definition) {
					throw new Error('Definition for attribute ' + attr + ' is missing!');
				}
				if (definition.domainValue) {
					if (!(definition.domainValue in this.props)) {
						throw new Error(definition.domainValue + ' not in props');
					}
					return (
						<Expandable title={t(definition.label)} closed key={attr}>
							<Field
								name={'attributes.' + attr}
								component={MultiCheckboxField}
								items={createDomainValueOptions(t, definition.prefix, this.props[definition.domainValue])}
								label={t(definition.label)}
							/>
						</Expandable>
					);
				} else {
					return (
						<React.Fragment key={attr}>
							<Field name={'attributes.' + attr} component={PortalInputField} type="text" label={t(definition.label)} />
							<hr />
						</React.Fragment>
					);
				}
			})
			.filter(Boolean);
		if (!inputs.length) {
			return null;
		}
		return (
			<PortalPageSection
				title={t('Shop_ManageShop_Products_CreateProduct_Title_Attributes')}
				description={t('Shop_ManageShop_Products_CreateProduct_Description_Attributes')}
			>
				<hr />
				{inputs}
			</PortalPageSection>
		);
	}
}

const mapStateToProps = (state: IStore) => ({
	colors: state.domainValues.colors,
	formats: state.domainValues.formats,
	formulations: state.domainValues.formulations,
	skinTypes: state.domainValues.skinTypes,
	specialities: state.domainValues.specialities,
	treatments: state.domainValues.treatments,
	hairType: state.domainValues.hairType,
	hairLength: state.domainValues.hairLength,
});

const EditProductAttributes = connect(mapStateToProps)(EditProductAttributesForm);

export { EditProductAttributes };
